import { app } from '../../app';
import { Controller } from './sp-group-name.controller';

app.component('spGroupName', {
    bindings: {
        groupName: '<',
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-group-name.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-name/sp-group-name.component.js